import RegPrivacyPolicy from "./RegPrivacyPolicy"

export default  RegPrivacyPolicy;
